// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"3940f957","416":"4ef0cd21","538":"7c0ad1c0","545":"346a604b","566":"1ad901cf","614":"6c9bd739","676":"e280edce"}[chunkId] + ".chunk.js";
};